import { DetailTable } from "./DetailTable";
import { useFinancialHighlightsData } from "../hooks/useFinancialHighlightsData";
import { JumpToSection } from "./JumpToSection";
import { MemoTable } from "./MemoTable";
import { useFinanceLab } from "@/entities/FinanceLab";

export function FinancialHighlights() {
    const {
        generalData,
        balanceSheetData,
        incomeStatementData,
        capitalStructureData,
        metricsProjectionsData,
        projectedFinancialsData,
        isLoading,
    } = useFinancialHighlightsData();

    const { isPolling } = useFinanceLab();

    const isLoadingMetrics = isLoading || isPolling;

    const projectedFinancialsColumns = [
        { field: "metric", headerName: "", flex: 1.5, minWidth: 200 },
        { field: "2026", headerName: "2026", flex: 1, minWidth: 120 },
        { field: "2027", headerName: "2027", flex: 1, minWidth: 120 },
        { field: "2028", headerName: "2028", flex: 1, minWidth: 120 },
    ];

    return (
        <>
            <div className="space-y-12">
                <DetailTable
                    title="General"
                    data={generalData}
                    isLoading={isLoadingMetrics}
                />
                <DetailTable
                    title="Balance Sheet"
                    data={balanceSheetData}
                    isLoading={isLoadingMetrics}
                />
                <DetailTable
                    title="Income Statement"
                    data={incomeStatementData}
                    isLoading={isLoadingMetrics}
                />
                <DetailTable
                    title="Capital Structure"
                    data={capitalStructureData}
                    isLoading={isLoadingMetrics}
                />
                <div>
                    <h4 className="heading-m mb-4">
                        Projected Financials Table (next 3 years)
                    </h4>
                    <MemoTable
                        data={projectedFinancialsData}
                        columns={projectedFinancialsColumns}
                    />
                </div>
                <DetailTable
                    title="Projected Post-Closing Metrics"
                    data={metricsProjectionsData}
                    isLoading={isLoadingMetrics}
                />
            </div>
            <JumpToSection
                targetSection="financial-highlights"
                label="Jump to Financials & Projections"
            />
        </>
    );
}
